import { useState } from "react";
import { cn } from "@/lib/utils";

interface ProjectImageWithFallbackProps {
  src: string;
  alt: string;
  className?: string;
  fallbackText?: string;
}

const ProjectImageWithFallback = ({
  src,
  alt,
  className,
  fallbackText = "Preview",
}: ProjectImageWithFallbackProps) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  const handleImageError = () => {
    setImageError(true);
    setImageLoading(false);
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  if (imageError) {
    return (
      <div
        className={cn(
          "flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900 text-white",
          className
        )}
      >
        <div className="text-center">
          <div className="w-12 h-12 mx-auto mb-2 opacity-50">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
            </svg>
          </div>
          <p className="text-sm opacity-75">{fallbackText}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={cn("relative", className)}>
      {imageLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-800 animate-pulse">
          <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        onError={handleImageError}
        onLoad={handleImageLoad}
        className={cn(
          "w-full h-full object-cover transition-opacity duration-300",
          imageLoading ? "opacity-0" : "opacity-100"
        )}
      />
    </div>
  );
};

export default ProjectImageWithFallback;
